import * as React from 'react';
/**
 *
 * Original name: stamp
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A551
 *
 */
export const StampSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M101 99H19v6h82v-6ZM84 58H72v-3.259a11.285 11.285 0 0 1 6.146-10.073l1.627-.838V34a19.022 19.022 0 0 0-19-19h-1.545a19.022 19.022 0 0 0-19 19v9.83l1.627.838A11.285 11.285 0 0 1 48 54.741V58H36a17.02 17.02 0 0 0-17 17v8h4v10h74V83h4v-8a17.02 17.02 0 0 0-17-17ZM25 75a11.012 11.012 0 0 1 11-11h18v-9.259a17.256 17.256 0 0 0-7.772-14.458V34a13.015 13.015 0 0 1 13-13h1.545a13.015 13.015 0 0 1 13 13v6.283A17.255 17.255 0 0 0 66 54.741V64h18a11.012 11.012 0 0 1 11 11v2H25v-2Zm66 12H29v-4h62v4Z", fill: "currentColor" })));
